import React, { useState, useEffect } from 'react';
import { Table, Button, Row, Col, Form, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import { selectStylesSm } from '~/Styles/reactSelectStyles';

const formatarMoeda = (valor) => {
  if (valor == null) return 'R$ 0,00';
  return 'R$ ' + Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const TabHierarquia = (props) => {
  const codigoDepartamento = props.codigoDepartamento;

  const [hierarquia, setHierarquia] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [nivel, setNivel] = useState('');
  const [teto, setTeto] = useState('');
  const [loading, setLoading] = useState(false);
  const [confirmacaoExcluir, setConfirmacaoExcluir] = useState({ show: false, item: null });

  useEffect(() => {
    if (codigoDepartamento) {
      carregarHierarquia();
      carregarUsuarios();
    }
  }, [codigoDepartamento]);

  const carregarHierarquia = async () => {
    setLoading(true);
    try {
      const resp = await api.buscarHierarquiaDepartamento(codigoDepartamento);
      setHierarquia(resp || []);
    } catch (e) {
      toast.error('Erro ao carregar hierarquia.');
    } finally {
      setLoading(false);
    }
  };

  const carregarUsuarios = async () => {
    try {
      const resp = await api.buscarUsuarioOptions('ativos');
      setUsuarios(resp || []);
    } catch (e) {
      // silencioso
    }
  };

  const opsUsuarios = usuarios.map((u) => {
    const nome = u.nome_completo ? u.nome_completo : (u.nome ? u.nome : (u.nome_usuario ? u.nome_usuario : String(u.codigo_usuario)));
    return { value: u.codigo_usuario, label: nome };
  });

  const handleAdicionar = async () => {
    if (!usuarioSelecionado) {
      toast.error('Selecione um usuário.');
      return;
    }
    if (!nivel || Number(nivel) < 1) {
      toast.error('Informe um nível válido (mínimo 1).');
      return;
    }
    if (!teto || Number(teto) <= 0) {
      toast.error('Informe um valor de teto maior que zero.');
      return;
    }
    try {
      await api.adicionarNivelHierarquia({
        codigo_departamento: codigoDepartamento,
        codigo_usuario: usuarioSelecionado.value,
        nivel: Number(nivel),
        teto: Number(teto),
      });
      toast.success('Nível adicionado com sucesso.');
      setUsuarioSelecionado(null);
      setNivel('');
      setTeto('');
      carregarHierarquia();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao adicionar nível.');
    }
  };

  const handleToggleStatus = async (item) => {
    try {
      await api.toggleStatusNivelHierarquia({
        codigo_departamento: codigoDepartamento,
        codigo_usuario: item.codigo_usuario,
      });
      toast.success('Status atualizado com sucesso.');
      carregarHierarquia();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao alterar status.');
    }
  };

  const handleExcluir = (item) => {
    setConfirmacaoExcluir({ show: true, item: item });
  };

  const handleConfirmarExcluir = async (confirmado) => {
    if (!confirmado) {
      setConfirmacaoExcluir({ show: false, item: null });
      return;
    }
    const item = confirmacaoExcluir.item;
    setConfirmacaoExcluir({ show: false, item: null });
    try {
      await api.excluirNivelHierarquia({
        codigo_departamento: codigoDepartamento,
        codigo_usuario: item.codigo_usuario,
      });
      toast.success('Nível removido com sucesso.');
      carregarHierarquia();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao remover nível.');
    }
  };

  return (
    <div>
      <Row className="align-items-end mb-3">
        <Col md={5}>
          <Form.Label style={{ fontSize: '0.85rem', fontWeight: 'bold', marginBottom: 2 }}>Usuário</Form.Label>
          <Select
            options={opsUsuarios}
            value={usuarioSelecionado}
            onChange={setUsuarioSelecionado}
            placeholder="Selecione..."
            isClearable
            styles={selectStylesSm}
          />
        </Col>
        <Col md={2}>
          <Form.Label style={{ fontSize: '0.85rem', fontWeight: 'bold', marginBottom: 2 }}>Nível</Form.Label>
          <Form.Control
            type="number"
            size="sm"
            min="1"
            value={nivel}
            onChange={(e) => { setNivel(e.target.value); }}
            placeholder="Ex: 1"
          />
        </Col>
        <Col md={3}>
          <Form.Label style={{ fontSize: '0.85rem', fontWeight: 'bold', marginBottom: 2 }}>Teto (R$)</Form.Label>
          <Form.Control
            type="number"
            size="sm"
            min="0.01"
            step="0.01"
            value={teto}
            onChange={(e) => { setTeto(e.target.value); }}
            placeholder="Ex: 1000.00"
          />
        </Col>
        <Col md={2}>
          <Button size="sm" variant="success" onClick={handleAdicionar} style={{ marginTop: 2 }}>
            Adicionar
          </Button>
        </Col>
      </Row>

      {loading ? (
        <p className="text-muted text-center">Carregando...</p>
      ) : hierarquia.length === 0 ? (
        <p className="text-muted text-center">Nenhum nível de hierarquia cadastrado.</p>
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Usuário</th>
              <th style={{ width: '70px', textAlign: 'center' }}>Nível</th>
              <th style={{ width: '130px', textAlign: 'right' }}>Teto</th>
              <th style={{ width: '80px', textAlign: 'center' }}>Status</th>
              <th style={{ width: '80px', textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {hierarquia.map((item) => {
              const ativo = item.status === 'A';
              return (
                <tr key={item.codigo_usuario}>
                  <td>{item.nome_usuario || '—'}</td>
                  <td style={{ textAlign: 'center' }}>{item.nivel}</td>
                  <td style={{ textAlign: 'right' }}>{formatarMoeda(item.teto)}</td>
                  <td style={{ textAlign: 'center' }}>
                    <Badge
                      style={{
                        backgroundColor: ativo ? '#28a745' : '#dc3545',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                      }}
                      onClick={() => { handleToggleStatus(item); }}
                      title="Clique para alterar status"
                    >
                      {ativo ? 'Ativo' : 'Inativo'}
                    </Badge>
                  </td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      title="Excluir"
                      onClick={() => { handleExcluir(item); }}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        </div>
      )}

      <ModalConfirmacao
        show={confirmacaoExcluir.show}
        title="Remover Nível"
        message={
          confirmacaoExcluir.item
            ? 'Deseja remover o nível ' + (confirmacaoExcluir.item.nivel || '') + ' do usuário "' + (confirmacaoExcluir.item.nome_usuario || '') + '"?'
            : ''
        }
        onClose={handleConfirmarExcluir}
      />
    </div>
  );
};

export default TabHierarquia;
